import { render, staticRenderFns } from "./ZnCateRenzhi.vue?vue&type=template&id=ad47692a"
import script from "./ZnCateRenzhi.vue?vue&type=script&lang=js"
export * from "./ZnCateRenzhi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports